import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24" aria-labelledby="category-section">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <SectionHeading
              id="category-section"
              eyebrow="线索分类"
              title="八个方向，覆盖你身边的公共议题"
              description="从社区治理到消费维权，从环境安全到财经疑点，选择你熟悉的领域，看看正在征集什么样的信息。"
            />
            <Link
              to="/leads"
              className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
            >
              查看全部线索
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((category, index) => (
            <Reveal key={category.id} delay={index * 60}>
              <Link
                to={`/leads?category=${category.id}`}
                className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-600">
                    <i className={`${category.icon} text-2xl`} />
                  </span>
                  <span className="rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-600">
                    {category.count} 条
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {category.name}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{category.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                  查看该分类 <i className="ri-arrow-right-line" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}